<template>
  <v-container>
   <v-row>
      <v-col
        xs="12"
      >
        <v-card>
          <v-card-title class="headline">Integrações</v-card-title>
          <v-card-text>
            <p>Nesta seção você encontra serviços que podem ser integrados ao EasyTools bem como instruções de como configurar as integrações.</p>
            <p class="text-info">Ex: Na integração com o Google disponível abaixo, você informa quais contas do Google serão utilizadas para gerenciar os contatos para recuperação de vendas pelos seus atendentes.</p>
            <v-row>
              <v-col
                v-for="i in integrations"
                :key="i.name"
                xs="12"
                sm="6"
                md="4"
                lg="3"
              >
                <v-card dark> 
                  <v-card-title>
                    <div>{{i.name}}</div>
                    <span class="grey--text subtitle-1">{{i.subtitle}}</span>
                  </v-card-title>
                  <v-divider class="mx-4"></v-divider>                  
                  <v-card-actions>
                    <v-btn color="info" @click="$router.push(i.link)">Configurar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>  
</template>

<script>
  export default {
    name: 'index',

    data () {
      return {
        integrations: [
          {            
            name: 'Google',
            link: '/integrations/google',
            img: 'https://upload.wikimedia.org/wikipedia/commons/2/2f/Google_2015_logo.svg',
            subtitle: 'Utilizado para gerenciar contatos e agendas'
          }
        ]
      }
    }
  }
</script>

<style lang="css" scoped>
</style>